(function () {
	const setImportant = (el, prop, value) => {
		if (!el) return;
		el.style.setProperty(prop, value, 'important');
	};

	const initStripCarousel = (sectionRoot) => {
		const carousel = sectionRoot.querySelector('[data-kk-strip-carousel]');
		const viewport = sectionRoot.querySelector('.popular-products__viewport');
		const track = sectionRoot.querySelector('.popular-products__wrapper');
		const prevButton = sectionRoot.querySelector('.hsc-popular-carousel__button--prev');
		const nextButton = sectionRoot.querySelector('.hsc-popular-carousel__button--next');

		if (!carousel || !viewport || !track || !prevButton || !nextButton) return;

		if (carousel.dataset.kkStripBound === 'true') {
			carousel.dispatchEvent(new Event('kk:strip-rebuild'));
			return;
		}
		carousel.dataset.kkStripBound = 'true';

		const mediaQuery = window.matchMedia('(max-width: 749px)');
		const desktopQuery = window.matchMedia('(min-width: 750px)');
		const autoplayEnabled = carousel.getAttribute('data-autoplay') === 'true';
		const pauseOnHover = carousel.getAttribute('data-pause-on-hover') === 'true';
		const autoplaySpeed = parseInt(carousel.getAttribute('data-autoplay-speed'), 10) || 4000;
		const desktopVisible = parseInt(carousel.getAttribute('data-desktop-visible'), 10) || 4;

		let slides = [];
		let currentIndex = 0;
		let slideWidth = 0;
		let visibleCount = 1;
		let autoplayTimer = null;
		let touchStartX = 0;
		let touchStartY = 0;
		let touchCurrentX = 0;
		let touchCurrentY = 0;
		let touchDirection = null;
		let isTouching = false;
		let suppressClick = false;
		const swipeThreshold = 45;

		const getSlides = () =>
			Array.prototype.slice.call(track.children).filter((item) => {
				if (
					!item.classList.contains('popular-products__item') &&
					!item.classList.contains('popular-products__item_placeholder')
				) {
					return false;
				}
				if (item.classList.contains('kk-voc-disabled')) return false;
				return window.getComputedStyle(item).display !== 'none';
			});

		const isDesktopActive = () => desktopQuery.matches;

		const stopAutoplay = () => {
			if (autoplayTimer) {
				clearInterval(autoplayTimer);
				autoplayTimer = null;
			}
		};

		const getMaxIndex = () => {
			if (!slides.length) return 0;
			return Math.max(slides.length - visibleCount, 0);
		};

		const updateNavVisibility = () => {
			const shouldShow = slides.length > visibleCount;
			prevButton.classList.toggle('is-visible', shouldShow);
			nextButton.classList.toggle('is-visible', shouldShow);
			prevButton.classList.toggle('is-hidden', !shouldShow);
			nextButton.classList.toggle('is-hidden', !shouldShow);
			setImportant(prevButton, 'display', shouldShow ? 'flex' : 'none');
			setImportant(nextButton, 'display', shouldShow ? 'flex' : 'none');
		};

		const setPosition = (animate) => {
			if (!slides.length) return;
			setImportant(track, 'transition', animate === false ? 'none' : 'transform 0.45s ease');
			setImportant(track, 'transform', `translate3d(${-1 * currentIndex * slideWidth}px, 0, 0)`);
			if (animate === false) {
				requestAnimationFrame(() => {
					setImportant(track, 'transition', 'transform 0.45s ease');
				});
			}
		};

		const goTo = (index, animate) => {
			if (!slides.length) return;
			const maxIndex = getMaxIndex();
			if (index < 0) index = maxIndex;
			if (index > maxIndex) index = 0;
			currentIndex = index;
			setPosition(animate);
			updateNavVisibility();
		};

		const startAutoplay = () => {
			stopAutoplay();
			if (!autoplayEnabled || !mediaQuery.matches) return;
			if (slides.length <= visibleCount) return;
			autoplayTimer = setInterval(() => {
				goTo(currentIndex + 1, true);
			}, autoplaySpeed);
		};

		const rebuild = () => {
			slides = getSlides();
			if (!slides.length) return;
			visibleCount = isDesktopActive() ? desktopVisible : 1;
			if (visibleCount < 1) visibleCount = 1;
			if (visibleCount > slides.length) visibleCount = slides.length;
			slideWidth = Math.round(slides[0].getBoundingClientRect().width);
			if (!slideWidth) return;
			if (currentIndex > getMaxIndex()) currentIndex = 0;
			setPosition(false);
			updateNavVisibility();
			startAutoplay();
		};

		prevButton.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			goTo(currentIndex - 1, true);
			startAutoplay();
		});

		nextButton.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			goTo(currentIndex + 1, true);
			startAutoplay();
		});

		viewport.addEventListener(
			'touchstart',
			(event) => {
				if (!mediaQuery.matches || event.touches.length !== 1 || slides.length <= visibleCount) return;
				const touch = event.touches[0];
				touchStartX = touch.clientX;
				touchStartY = touch.clientY;
				touchCurrentX = touchStartX;
				touchCurrentY = touchStartY;
				touchDirection = null;
				isTouching = true;
				suppressClick = false;
				stopAutoplay();
				setImportant(track, 'transition', 'none');
			},
			{ passive: true }
		);

		viewport.addEventListener(
			'touchmove',
			(event) => {
				if (!isTouching || event.touches.length !== 1) return;
				const touch = event.touches[0];
				touchCurrentX = touch.clientX;
				touchCurrentY = touch.clientY;
				const deltaX = touchCurrentX - touchStartX;
				const deltaY = touchCurrentY - touchStartY;
				if (!touchDirection && (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6)) {
					touchDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
				}
				if (touchDirection !== 'horizontal') return;
				event.preventDefault();
				suppressClick = true;
				const maxIndex = getMaxIndex();
				let dragX = deltaX;
				if ((currentIndex === 0 && deltaX > 0) || (currentIndex === maxIndex && deltaX < 0)) {
					dragX = deltaX * 0.3;
				}
				setImportant(track, 'transform', `translate3d(${-1 * currentIndex * slideWidth + dragX}px, 0, 0)`);
			},
			{ passive: false }
		);

		viewport.addEventListener(
			'touchend',
			() => {
				if (!isTouching) return;
				const deltaX = touchCurrentX - touchStartX;
				const wasHorizontal = touchDirection === 'horizontal';
				isTouching = false;
				touchDirection = null;
				if (wasHorizontal && Math.abs(deltaX) >= swipeThreshold) {
					goTo(currentIndex + (deltaX < 0 ? 1 : -1), true);
				} else {
					setPosition(true);
				}
				startAutoplay();
			},
			{ passive: true }
		);

		viewport.addEventListener(
			'touchcancel',
			() => {
				if (!isTouching) return;
				isTouching = false;
				touchDirection = null;
				setPosition(true);
				startAutoplay();
			},
			{ passive: true }
		);

		viewport.addEventListener(
			'click',
			(event) => {
				if (!suppressClick) return;
				event.preventDefault();
				event.stopPropagation();
				suppressClick = false;
			},
			true
		);

		viewport.addEventListener('mouseenter', () => {
			if (pauseOnHover) stopAutoplay();
		});
		viewport.addEventListener('mouseleave', startAutoplay);
		viewport.addEventListener('focusin', stopAutoplay);
		viewport.addEventListener('focusout', startAutoplay);

		document.addEventListener('visibilitychange', () => {
			if (document.hidden) stopAutoplay();
			else startAutoplay();
		});

		window.addEventListener('resize', rebuild);
		if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', rebuild);
		else if (mediaQuery.addListener) mediaQuery.addListener(rebuild);
		if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', rebuild);
		else if (desktopQuery.addListener) desktopQuery.addListener(rebuild);

		carousel.addEventListener('kk:strip-rebuild', rebuild);
		document.addEventListener('kk:collection:voc-hidden', rebuild);

		rebuild();
	};

	const readDisableList = (collectionId) => {
		const key = `"cs_${collectionId}"`;
		const scripts = document.scripts;
		for (let i = 0; i < scripts.length; i++) {
			const text = scripts[i].textContent || '';
			const idx = text.indexOf(key);
			if (idx === -1) continue;
			const match = text.slice(idx, idx + 200000).match(/"disableList"\s*:\s*\[([^\]]*)\]/);
			if (!match) continue;
			return { found: true, list: (match[1].match(/\d+/g) || []).map(String) };
		}
		return { found: false, list: [] };
	};

	const applyVocHide = (root = document) => {
		const payloadScripts = root.querySelectorAll
			? root.querySelectorAll('script[id^="kk-collection-payload-"]')
			: [];
		const scripts = payloadScripts.length
			? payloadScripts
			: document.querySelectorAll('script[id^="kk-collection-payload-"]');

		scripts.forEach((script) => {
			let data;
			try {
				data = JSON.parse(script.textContent);
			} catch (error) {
				return;
			}
			const collectionId = data?.collection?.id;
			if (!collectionId) return;
			const parsed = readDisableList(collectionId);
			if (!parsed.found || !parsed.list.length) return;
			const ids = {};
			parsed.list.forEach((id) => {
				ids[id] = true;
			});
			const scope =
				(root.querySelector && root.querySelector('#product-grid')) ||
				(root.querySelector && root.querySelector('.popular-products__wrapper')) ||
				script.previousElementSibling ||
				root;
			if (!scope || !scope.querySelectorAll) return;
			scope.querySelectorAll('[data-colorway-variant-ids]').forEach((card) => {
				const vids = (card.getAttribute('data-colorway-variant-ids') || '').split(',');
				if (vids.some((id) => ids[id])) card.classList.add('kk-voc-disabled');
			});
		});
	};

	const initAll = (root = document) => {
		applyVocHide(root);
		if (root.matches && root.matches('[data-popular-products-section], [data-kk-collection-root]')) {
			initStripCarousel(root);
		}
		if (root.querySelectorAll) {
			root.querySelectorAll('[data-popular-products-section], [data-kk-collection-root]').forEach((sectionRoot) => {
				initStripCarousel(sectionRoot);
			});
		}
		if (typeof window.initProductCardSliders === 'function') {
			window.initProductCardSliders(root);
		}
	};

	window.kkCollectionRebind = initAll;

	initAll();

	document.addEventListener('shopify:section:load', (event) => {
		initAll(event.target || document);
	});
})();
